import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ESRState } from "../../types/data";
import { ThreadDetail } from "./ThreadDetail";
import { ThreadList } from "./ThreadList";
import { AttachmentList } from "./AttachmentList";
import { DataAction } from "../../types/action";
import { Dispatch } from "redux";
import { SentNotificationsList } from "./SentNotificationsList";
import { useNavigate } from "react-router-dom";

export const Drawer: FC = () => {
	const dispatch = useDispatch<Dispatch<DataAction>>();

	const filters = useSelector((state: ESRState) => state.drawer.filters);

	const threads = useSelector((state: ESRState) => {
		let threads = Object.values(state.threads);
		if (filters.questionId) {
			threads = threads.filter(
				(thread) => thread.question_id === filters.questionId,
			);
		}
		return threads;
	});

	const threadsOpen = useSelector(
		(state: ESRState) => state.drawer.threadsOpen,
	);
	const threadsLoading = useSelector(
		(state: ESRState) => state.drawer.threadsLoading,
	);
	const attachmentsOpen = useSelector(
		(state: ESRState) => state.drawer.attachmentsOpen,
	);
	const sentNotificationsOpen = useSelector(
		(state: ESRState) => state.drawer.sentNotificationsOpen,
	);
	const selectedThreadId = useSelector(
		(state: ESRState) => state.drawer.selectedThreadId,
	);

	const selectedThread =
		threads.find((thread) => thread.id === selectedThreadId) ?? null;
		
	const navigate = useNavigate();
	const setCurrentThread = (threadId: number) => {
		dispatch({
			type: "UPDATE_DRAWER_STATE",
			update: {
				selectedThreadId: threadId,
			},
		});
		const selectedThread =
		threads.find((thread) => thread.id === threadId) ?? null;
		if(selectedThread){
			const queryParam = `?thread_id=${selectedThread.id}`;
			const esrId = selectedThread.addendum_id || selectedThread.esr_id;
			const activeLabel = selectedThread.addendum_label || 'initial';
			const activeId = selectedThread.esr_id;
			if (selectedThread?.question_id) {
				navigate(`/esr/${esrId}/${activeLabel}/${activeId}/redirect/${selectedThread.question_id}${queryParam}`, {replace: true});
			} else {
				navigate(`/esr/${esrId}/${activeLabel}/${activeId}/0${queryParam}`, {replace: true});
        }
		}
	};

	const closeDrawer = () =>
		dispatch<DataAction>({
			type: "UPDATE_DRAWER_STATE",
			update: {
				threadsOpen: false,
				attachmentsOpen: false,
				sentNotificationsOpen: false,
				selectedThreadId: -1,
				filters: {},
			},
		});

	return (
		<>
			<AttachmentList open={attachmentsOpen} onClose={closeDrawer} />

			<SentNotificationsList open={sentNotificationsOpen} onClose={closeDrawer} />

			<ThreadList
				threads={threads}
				open={threadsOpen && selectedThreadId === -1}
				onClose={closeDrawer}
				onSelectThread={setCurrentThread}
			/>

			<ThreadDetail
				thread={selectedThread}
				loading={threadsLoading}
				open={threadsOpen && selectedThreadId !== -1}
				onClose={closeDrawer}
				onBack={() => setCurrentThread(-1)}
			/>
		</>
	);
};
